<template>
  <div v-if="orderNumber?.length" class="margin-bottom-s">
    <h5>
      {{ orderInformationText }}
    </h5>
    <div v-for="invoiceNumber in orderNumber" :key="invoiceNumber" class="margin-top-xxs">
      <router-link :to="orderDetailsView(invoiceNumber)" class="link-body"> {{ orderText }} {{ invoiceNumber }} </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { TRACK_PACKAGE } from 'config';

const props = defineProps({
  orderDetails: {
    type: Object,
    default: null,
  },
});

const { orderInformationText, orderText } = TRACK_PACKAGE;
const orderDetails = computed(() => props.orderDetails || {});
const { orderNumber } = orderDetails.value || {};

const orderDetailsView = (orderNumber) => {
  const selectedOrder = props.orderDetails?.items?.find((item) => orderNumber === item.orderNumber);

  return {
    name: 'Order Details',
    params: { orderNumber },
    query: { o: selectedOrder?.orderToken },
  };
};
</script>
